import {z} from "zod/v4-mini"

export const textureGradientTypeSchema = z.enum(["LINEAR", "QUADRATIC", "EASING", "DIAGONAL", "SPHERICAL", "QUADRATIC_SPHERE", "RADIAL"])

export type TextureGradientType = z.infer<typeof textureGradientTypeSchema>
